import styled from 'vue-styled-components'

const theme = {primary: String}

const ThemedMenuZone = styled('div', theme)`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #8e8e8e;
        transition: color 0.3s;
        &.active {
          color: ${props => props.primary};
        }
`

export default ThemedMenuZone
